<template>
  <div class="account-page" @keydown.enter="verifyOtpOnEnter">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <!-- Page Content -->

      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <!-- Account Content -->
              <div class="account-content">
                <div style="display: flex; flex-direction: row;">
                  <div class="col-md-7 col-lg-6 mr-5 login-left">
                    <img :src="'https://app.bhilwarahealthcare.in' + loginPageImage" class="img-fluid" alt="Login Banner"
                      style="height: 370px; border-radius: 15px; margin-left: -48px; margin-top:5px;" />
                  </div>
                  <div class="col-md-12 col-lg-5 mt-2 login-right">
                    <div class="login-header">
                      <h3 class="text-center mt-2">Enter OTP</h3>
                      <!-- <p class="small text-muted">Enter your OTP</p> -->
                    </div>

                    <!-- Forgot Password Form -->
                    <div id="app">
                      <div class="otp-container">
                        <div class="otp-container">
                          <input v-for="(value, index) in otpValues" :key="index" type="text" maxlength="1"
                            class="otp-input mt-2 ml-1 mr-1" :value="value"
                            @input="handleInput(index, $event.target.value)" @keydown.backspace="handleBackspace(index)"
                            ref="otpFields" @keypress="onlyNumber" @keydown.enter.prevent="verify_OTP()" pattern="[0-9]*"
                            autofocus />
                        </div>


                      </div>
                    </div>
                    <div class="text-center mt-4" v-show="!resendOTP">
                      <p class="small text-muted">
                        Resend OTP in
                        <span>
                          <div id="countdown">
                            <div id="countdown-number"></div>
                            <svg>
                              <circle r="18" cx="20" cy="20"></circle>
                            </svg>
                          </div>
                        </span>
                        seconds
                      </p>
                    </div>
                    <div>
                      <div>
                        <router-link class="forgot-link mt-4 ml-1" to="/login">Change Mobile No</router-link>
                      </div>

                      <div v-if="resendOTP" class="m-1">
                        <a href="javascript:void(0);" @click="resend_OTP()" class="forgot-link">Resend OTP
                        </a>
                      </div>
                    </div>
                    <button ref="verifyOtpButton" class="btn btn-primary btn-block btn-lg login-btn mt-2" type="submit"
                      @click="verify_OTP()">
                      Verify OTP
                    </button>

                  </div>

                </div>
              </div>
              <!-- /Account Content -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>
 
<script>
import CommonApi from "../../services/CommonApi";
import axios from "axios";
export default {
  props: ["mobile"],
  data() {
    return {
      resendOTP: false,
      cleartime: "",
      otpValues: ['', '', '', '', '', ''],
      config: CommonApi,
      loginPageImage: "",
    };
  },

  computed: {
    isOtpValid() {
      return this.otp.every((digit) => /\d/.test(digit)); // Check if all digits are numbers
    },
  },
  watch: {
    resendOTP: function () {
      console.log("any of these variables changed");
    },
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://app.bhilwarahealthcare.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].logo;
            this.loginPageImage = res.data.data[0].login_page;
            console.log(res)
          }

          if (res.data.status_code == 404) {
            if (window.location.hostname == "bhilwarahealthcare.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://bhilwarahealthcare.in");
            }
          }

          this.$swal.close();
        });
    },


    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    handleInput(index, value) {
      if (value.length > 1) {
        return;
      }
      this.otpValues[index] = value;
      if (value.length === 1 && index < this.otpValues.length - 1) {
        this.$refs.otpFields[index + 1].focus();
      }
    },
    handleBackspace(index) {
      if (this.otpValues[index] !== '') {
        this.otpValues[index] = '';
      } else if (index > 0) {
        this.$refs.otpFields[index - 1].focus();
      }
    },

    startCountDown() {
      var countdownNumberEl = document.getElementById("countdown-number");
      var countdown = 120;

      countdownNumberEl.textContent = countdown;

      this.cleartime = setInterval(function () {
        countdown = --countdown <= 1 ? 0 : countdown;
        countdownNumberEl.textContent = countdown;
      }, 1000);
    },

    stopCountDown(time) {
      var self = this;
      setTimeout(function () {
        clearInterval(self.cleartime);
        self.resendOTP = true;
      }, time);
    },

    resend_OTP() {
      this.otpValues = ["", "", "", "", "", ""];
      this.resendOTP = false;
      if (this.mobile) {
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.mobile);
        CommonApi.post_data(
          // "sahaj.api.send_otp" 
          "sahaj.api.send_otp_registered_user", bodyFormData, true).then(
            (res) => {
              if (!res.status_code == 200) {
                this.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: res.message,
                  showConfirmButton: true,
                });
              }
            }
          );
      }
      this.startCountDown();
      this.stopCountDown(120000);
    },

    verify_OTP() {
      const fullOtp = this.otpValues.join('');

      if (this.mobile && fullOtp) {
        this.$swal({
          text: "Verifying OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });

        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.mobile);
        bodyFormData.append("otp", fullOtp);

        CommonApi.post_data("sahaj.api.verify_otp_code", bodyFormData, true).then((res) => {
          console.log("Verification Response:", res); // Log the response for debugging

          if (res.status_code === 200) {
            if (res.data) {
              var userJson = {
                username: res.data.full_name,
                user: res.data.user,
                ...res.data.key_details,
              };

              if (res.data.healthcare_id && res.data.healthcare_id.length) {
            this.$store.dispatch("user/setUserType", "doctor");
            this.$store.dispatch("user/setUserID", res.data.healthcare_id[0].name);
            userJson.image = res.data.healthcare_id[0].image;
            userJson.qualification = res.data.healthcare_id[0].qualification;
            localStorage.setItem("userInfo", JSON.stringify(userJson));
            const healthcareCategory = res.data.healthcare_id[0].healthcare_category;
            localStorage.setItem('healthcareCategory', healthcareCategory);

            // Navigate to the doctor's index
            this.$router.push("/doctor/index").catch((err) => {
              console.error("Router Error:", err);
            });
              } else if (res.data.patient_id && res.data.patient_id.length) {
                console.log("User is a patient"); // Log for patient type
                this.$store.dispatch("user/setUserType", "patient");
                this.$store.dispatch("user/setUserID", res.data.patient_id[0].name);
                userJson.image = res.data.patient_id[0].image;
                userJson.dob = res.data.patient_id[0].dob;
                userJson.city = res.data.patient_id[0].city;

                localStorage.setItem("userInfo", JSON.stringify(userJson));

                this.$router.push("/patient/index").catch((err) => {
                  console.error("Router Error:", err);
                });
              } else if (res.data.hospital_id && res.data.hospital_id.length) {
                console.log("User is a hospital"); // Log for hospital type
                this.$store.dispatch("user/setUserType", "hospital");
                this.$store.dispatch("user/setUserID", res.data.hospital_id[0].name);
                userJson.hospital_name = res.data.hospital_id[0].hospital;
                userJson.image = res.data.hospital_id[0].image;
               
                console.log("Hospital ID exists:", res.data.hospital_id[0]);
                localStorage.setItem("userInfo", JSON.stringify(userJson));
                localStorage.setItem("hospitalID", JSON.stringify(res.data.hospital_id[0]))
                
                this.$router.replace("/hospital/appointment").catch((err) => {
                  console.error("Router Error:", err);
                });
              } else {
                console.log("User type not recognized"); // Log for unrecognized type
              }

              this.$swal.close();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "User Not Registered",
                text: "This Mobile Number Not Registered With Us",
                showConfirmButton: true,
              });
            }
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      }
    },


//     verify_OTP() {
//       const fullOtp = this.otpValues.join('');
//       if (this.mobile && fullOtp) {
//         this.$swal({
//           text: "Verifying OTP...",
//           showConfirmButton: false,
//           allowOutsideClick: false,
//           didOpen: () => {
//             this.$swal.showLoading();
//           },
//         });
//         var bodyFormData = new FormData();
//         bodyFormData.append("phone", this.mobile);
//         bodyFormData.append("otp", fullOtp);
//         CommonApi.post_data(
//           "sahaj.api.verify_otp_code",
//           bodyFormData,
//           true
//         ).then((res) => {
//           if (res.status_code === 200) {
//             if (!res.data == false) {
//               var userJson = {
//                 username: res.data.full_name,
//                 user: res.data.user,
//                 ...res.data.key_details,
//               };
//               if (res.data.healthcare_id && res.data.healthcare_id.length) {
         

//                 this.$store.dispatch("user/setUserType", "doctor");
//                 this.$store.dispatch(
//                   "user/setUserID",
//                   res.data.healthcare_id[0].name
//                 );
//                 userJson.image = res.data.healthcare_id[0].image;
//                 userJson.qualification = res.data.healthcare_id[0].qualification;

//                 if (res.data.healthcare_id && res.data.healthcare_id.length) {
//     const healthcareCategory = res.data.healthcare_id[0].healthcare_category;
//     localStorage.setItem('healthcareCategory', healthcareCategory);
// }

//               }
//               else {
//                 this.$store.dispatch("user/setUserType", "patient");
//                 this.$store.dispatch(
//                   "user/setUserID",
//                   res.data.patient_id[0].name
//                 );
//                 userJson.image = res.data.patient_id[0].image;
//                 userJson.dob = res.data.patient_id[0].dob;
//                 userJson.city = res.data.patient_id[0].city;
//               }
//               localStorage.setItem("userInfo", JSON.stringify(userJson));
//               if (this.user === "doctor") {
//                 this.$router.push("/doctor/index");
//               } else {
//                 this.$router.push("/patient/index");
//               }
//               this.$swal.close();
//             } else {
//               this.$swal.fire({
//                 icon: "error",
//                 title: "User Not Registered",
//                 text: "This Mobile Number Not Registered With Us",
//                 showConfirmButton: true,
//               });
//             }
//           } else {
//             this.$swal.fire({
//               icon: "error",
//               title: "Error",
//               text: res.message,
//               showConfirmButton: true,
//             });
//           }
//         });
//       }
//     },
    verifyOtpOnEnter(event) {
      if (event.key === 'Enter' && this.isOtpValid) {
        // If the Enter key is pressed and the OTP is valid, simulate a click on the "Verify OTP" button
        this.$refs.verifyOtpButton.click();
      }
    },



  },

  mounted() {
    this.get_practitioner_profile();
    this.startCountDown();
    this.stopCountDown(120000);
    const firstInputField = this.$refs.otpFields[0];
    if (firstInputField) {
      firstInputField.focus(); // Set focus
      firstInputField.select(); // Select the content
    }

  },
  destroyed() {
    this.stopCountDown(0);
  },
};
</script>
 
<style scoped>
body {
  height: 100%;
  width: 100%;
  background-color: #333;
}

.opt {
  text-align: center;
  letter-spacing: 15px;
}

#countdown {
  position: relative;
  margin: auto;
  margin-top: 8px;
  height: 40px;
  width: 40px;
  text-align: center;
}

#countdown-number {
  color: black;
  display: inline-block;
  line-height: 40px;
}

svg {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  transform: rotateY(-180deg) rotateZ(-90deg);
}

svg circle {
  stroke-dasharray: 113px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  stroke-width: 2px;
  stroke: red;
  fill: none;
  animation: countdown 120s linear forwards;
}

.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  margin: 0 10px;
  border: none;
  border-bottom: 2px solid #403636;
  box-shadow: none;
  background-color: transparent;
  color: #140b0b;
  transition: all 0.3s ease-in-out;
  font-family: Arial, Helvetica, sans-serif;
}

.otp-input:focus {
  outline: none;
  border-bottom: 2px solid #09e5ab;
}

@keyframes countdown {
  from {
    stroke-dashoffset: 0px;
  }

  to {
    stroke-dashoffset: 113px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/EnterOTP.vue